import React from "react";
import PhoneInput from "../../../shared/PhoneInput";
import Toggle from "../../../shared/Toggle";
import ValidatedInput from "../../../shared/ValidatedInput";
import { validateEmail } from "../../../../lib";

const ParentContactInfo = React.memo(function ParentContactInfo({
  countries,
  getProfileFieldLabel,
  isProfileFieldRequired,
  onChangeProfile,
  onChangeProfileEvt,
  profile: { address, doParentsShareResidence, father = {}, mother = {} } = {
    person: {},
  },
  profileValidationErrors,
  showFormValidation,
  updateProfileValidation,
}) {
  const isFatherNA = father.isDeceasedOrNotInContact;
  const isMotherNA = mother.isDeceasedOrNotInContact;

  return (
    <div className="student-profile-form-section">
      <p className="profile-section-title">Parent Contact Information</p>
      <div className="parent-contact-na-checkbox">
        <label>
          <input
            type="checkbox"
            checked={!!isFatherNA}
            onChange={(e) => {
              onChangeProfile(
                "father.isDeceasedOrNotInContact",
                e.target.checked,
              );
              if (e.target.checked) {
                onChangeProfile("father.name", "");
                onChangeProfile("father.email", "");
                onChangeProfile("father.phoneNumber", "");
                onChangeProfile("father.phoneCountryID", "");
                onChangeProfile("doParentsShareResidence", null);
                // clear validation errors for fields that have custom validate callbacks, so they don't block form submission
                updateProfileValidation("father.email", true);
                updateProfileValidation("father.phoneNumber", true);
              }
            }}
          />{" "}
          N/A (father is deceased or not in contact)
        </label>
      </div>
      <div className="student-profile-form-grid parent-contact-info-grid">
        <ValidatedInput
          className="input-container"
          disabled={isFatherNA}
          label={getProfileFieldLabel("Father's Name", "father.name")}
          name="father.name"
          onChange={onChangeProfileEvt}
          required={!isFatherNA && isProfileFieldRequired("father.name")}
          showRequired={showFormValidation}
          showValidation={showFormValidation}
          value={father.name}
        />
        <ValidatedInput
          className="input-container"
          disabled={isFatherNA}
          label={getProfileFieldLabel("Father's Email", "father.email")}
          name="father.email"
          onChange={onChangeProfileEvt}
          required={!isFatherNA && isProfileFieldRequired("father.email")}
          showRequired={showFormValidation}
          showValidation={showFormValidation}
          validate={(email) => {
            const isValid = validateEmail(email);
            updateProfileValidation("father.email", isValid);
            return isValid;
          }}
          validationMessage="Invalid email address"
          value={father.email}
        />
        <div
          className={`input-container ${
            !isFatherNA &&
            (profileValidationErrors.indexOf("father.phoneNumber") >= 0 ||
              (showFormValidation &&
                isProfileFieldRequired("father.phoneNumber") &&
                !father.phoneNumber))
              ? "error"
              : ""
          }`}
        >
          <label>
            {getProfileFieldLabel("Father's Phone", "father.phoneNumber")}
          </label>
          <PhoneInput
            countries={countries || []}
            countryId={father.phoneCountryID}
            defaultCountryName={address && address.country} //fallback on country associated with student's address
            disabled={isFatherNA}
            name="father.phoneNumber"
            error={profileValidationErrors.indexOf("father.phoneNumber") >= 0}
            validate={(isValid) =>
              updateProfileValidation("father.phoneNumber", isValid)
            }
            onChange={(cell, countryId) => {
              onChangeProfile("father.phoneNumber", cell);
              onChangeProfile("father.phoneCountryID", countryId);
            }}
            value={father.phoneNumber}
          />
        </div>
      </div>
      <div className="parent-contact-na-checkbox">
        <label>
          <input
            type="checkbox"
            checked={!!isMotherNA}
            onChange={(e) => {
              onChangeProfile(
                "mother.isDeceasedOrNotInContact",
                e.target.checked,
              );
              if (e.target.checked) {
                onChangeProfile("mother.name", "");
                onChangeProfile("mother.email", "");
                onChangeProfile("mother.phoneNumber", "");
                onChangeProfile("mother.phoneCountryID", "");
                onChangeProfile("doParentsShareResidence", null);
                // clear validation errors for fields that have custom validate callbacks, so they don't block form submission
                updateProfileValidation("mother.email", true);
                updateProfileValidation("mother.phoneNumber", true);
              }
            }}
          />{" "}
          N/A (mother is deceased or not in contact)
        </label>
      </div>
      <div className="student-profile-form-grid parent-contact-info-grid">
        <ValidatedInput
          className="input-container"
          disabled={isMotherNA}
          label={getProfileFieldLabel("Mother's Name", "mother.name")}
          name="mother.name"
          onChange={onChangeProfileEvt}
          required={!isMotherNA && isProfileFieldRequired("mother.name")}
          showRequired={showFormValidation}
          showValidation={showFormValidation}
          value={mother.name}
        />
        <ValidatedInput
          className="input-container"
          disabled={isMotherNA}
          label={getProfileFieldLabel("Mother's Email", "mother.email")}
          name="mother.email"
          onChange={onChangeProfileEvt}
          required={!isMotherNA && isProfileFieldRequired("mother.email")}
          showRequired={showFormValidation}
          showValidation={showFormValidation}
          validate={(email) => {
            const isValid = validateEmail(email);
            updateProfileValidation("mother.email", isValid);
            return isValid;
          }}
          validationMessage="Invalid email address"
          value={mother.email}
        />
        <div
          className={`input-container ${
            !isMotherNA &&
            (profileValidationErrors.indexOf("mother.phoneNumber") >= 0 ||
              (showFormValidation &&
                isProfileFieldRequired("mother.phoneNumber") &&
                !mother.phoneNumber))
              ? "error"
              : ""
          }`}
        >
          <label>
            {getProfileFieldLabel("Mother's Phone", "mother.phoneNumber")}
          </label>
          <PhoneInput
            countries={countries || []}
            countryId={mother.phoneCountryID}
            defaultCountryName={address && address.country} //fallback on country associated with student's address
            disabled={isMotherNA}
            name="mother.phoneNumber"
            error={profileValidationErrors.indexOf("mother.phoneNumber") >= 0}
            validate={(isValid) =>
              updateProfileValidation("mother.phoneNumber", isValid)
            }
            onChange={(cell, countryId) => {
              onChangeProfile("mother.phoneNumber", cell);
              onChangeProfile("mother.phoneCountryID", countryId);
            }}
            value={mother.phoneNumber}
          />
        </div>
      </div>
      <div className="parent-contact-residence-toggle">
        <ValidatedInput
          input={
            <Toggle
              allowNoOption={true}
              className="toggle-container"
              disabled={isFatherNA || isMotherNA}
              options={[
                {
                  value: true,
                  display: "Yes",
                },
                {
                  value: false,
                  display: "No",
                },
              ]}
            />
          }
          disabled={isFatherNA || isMotherNA}
          label={getProfileFieldLabel(
            "Both parents reside at same address",
            "doParentsShareResidence",
          )}
          labelClassName="uppercase-text xs-text accent-text mb-4 block"
          name="doParentsShareResidence"
          onChange={onChangeProfile}
          required={
            !(isFatherNA || isMotherNA) &&
            isProfileFieldRequired("doParentsShareResidence")
          }
          showRequired={
            showFormValidation &&
            doParentsShareResidence !== true &&
            doParentsShareResidence !== false
          }
          value={doParentsShareResidence}
        />
      </div>
    </div>
  );
});

export default ParentContactInfo;
